/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business 重要課題 CRUD API クライアント。
 * @graph-connects /key-issues [calls] 重要課題 CRUD エンドポイント
 */

import { request } from './api.js';
import type {
  KeyIssueInput,
  KeyIssueListResponse,
  KeyIssueMutationResponse,
} from '../types/key-issue.js';

/** @graph-connects none */
export const keyIssueApi = {
  list: (): Promise<KeyIssueListResponse> => request<KeyIssueListResponse>('/key-issues'),
  create: (input: KeyIssueInput): Promise<KeyIssueMutationResponse> =>
    request<KeyIssueMutationResponse>('/key-issues', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  update: (id: string, input: KeyIssueInput): Promise<KeyIssueMutationResponse> =>
    request<KeyIssueMutationResponse>(`/key-issues/${encodeURIComponent(id)}`, {
      method: 'PUT',
      body: JSON.stringify(input),
    }),
  remove: (id: string): Promise<{ deleted: boolean }> =>
    request<{ deleted: boolean }>(`/key-issues/${encodeURIComponent(id)}`, { method: 'DELETE' }),
  reorder: (orderedIds: string[]): Promise<KeyIssueListResponse> =>
    request<KeyIssueListResponse>('/key-issues/reorder', {
      method: 'PUT',
      body: JSON.stringify({ orderedIds }),
    }),
};
